import { render, staticRenderFns } from "./WordChoosePic.vue?vue&type=template&id=e7bd2002&scoped=true&"
import script from "./WordChoosePic.vue?vue&type=script&lang=js&"
export * from "./WordChoosePic.vue?vue&type=script&lang=js&"
import style0 from "./WordChoosePic.vue?vue&type=style&index=0&id=e7bd2002&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7bd2002",
  null
  
)

export default component.exports